import { pageService } from "../pages";
import { pageMeta } from "../pages/pageMetadata";
import { blockService } from "../blocks";
import { siteService } from "../sites";
import { convertIntroduction as convert } from "./introductionConversion";
import type { EditorPage } from "./editor.types";

export const convertIntroduction = (
  versionId: string,
  page: EditorPage,
  description: string,
) =>
  convert(versionId, page, description, {
    list: blockService.list,
    save: blockService.saveDocument,
    clear: (id) => siteService.updateDraft(id, { description: null }),
  });

export const convertPageDescription = (page: EditorPage) =>
  convert(`${page.site_version_id}:${page.id}`, page, page.description!, {
    list: blockService.list,
    save: blockService.saveDocument,
    clear: () =>
      pageService.update(page.id, {
        seo: { ...pageMeta(page), descriptionInBlocks: true },
      }),
  });
